import { Decimal } from 'decimal.js-light';

export const authorityValues: string[] = Array.from(
    { length: 12 },
    (_, i) => new Decimal(0.25 + i * 0.05).toFixed(2),
);
